import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { NotAFit } from './pages/NotAFit';
import { ThankYou } from './pages/ThankYou';
import { GoogleTagManager } from './components/GoogleTagManager';
export function App() {
  useEffect(() => {
    // Set browser tab title
    document.title = 'RIA Catalyst';
    // Set/refresh meta description for SEO and social previews
    const ensureMeta = (name: string, content: string) => {
      let tag = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
      if (!tag) {
        tag = document.createElement('meta');
        tag.name = name;
        document.head.appendChild(tag);
      }
      tag.content = content;
    };
    ensureMeta('description', 'RIA Catalyst matches $250M+ wealth advisors with the perfect independent RIA and negotiates your transition capital — at zero cost to you.');
  }, []);
  return <BrowserRouter data-id="element-0">
      <GoogleTagManager data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<Landing data-id="element-4" />} data-id="element-3" />
        <Route path="/not-a-fit" element={<NotAFit data-id="element-6" />} data-id="element-5" />
        <Route path="/thankyou" element={<ThankYou data-id="element-8" />} data-id="element-7" />
      </Routes>
    </BrowserRouter>;
}